/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import MapView from '@arcgis/core/views/MapView';
import WebMap from '@arcgis/core/WebMap';
import {Results} from '@ion/core/src/services/GroupProperties';
import {GenericObject} from '@ion/core/src/types/entities';
import {ColorModeEnum, CreateGeoFenceTypeEnum} from '@ion/dls/src/types/types';

/**
 * History Default Input Events
 */
export enum HistoryDefaultInputsEnum {
  input1 = 'input1',
  input2 = 'input2',
  input3 = 'input3',
  input4 = 'input4',
  input5 = 'input5',
  input6 = 'input6',
  input7 = 'input7'
};

export interface BoundaryLayerProps {
  boundary?: number[][];
}

export interface BoundaryPanelProps {
  boundary?: number[][];
  boundaryPanelOpen: boolean;
  selectedBoundaryTool: CreateGeoFenceTypeEnum
  onApplyBoundary: Function;
  toggleShowBoundaryPanel: Function;
}

export interface MapProps {
  webMapId: Results;
  basemap: string;
  storeTrackingExtent?: Function;
  onResetSelectedAsset?: Function;
  onMapViewChange?: Function;
  setOperationalLayers?: Function;
}

export interface FindNearbyProps {
  findNearbyDistance?: number;
  isFindNearbyPanelActive?: Boolean;
  setFindNearbyPanelActive?: Function;
  setFindNearbyDistance?: Function;
}

export interface MapViewProps {
  map?: WebMap;
  initialExtent?: GenericObject
  containerRef?: React.RefObject<HTMLDivElement>;
  ui?: {
    components: any[]
  },
  constraints?: {
    minZoom: number,
    rotationEnabled: boolean
  },
  customExtent?: any,
  popup?: {
    actions: [],
    highlightEnabled: boolean,
    spinnerEnabled: boolean,
    dockOptions: {
      breakpoint: boolean
    }
  },
  highlightOptions?: {
    haloColor: number[],
    fillOpacity: number
  }
}

export interface MapContainerProps {
  map?: WebMap;
  view?: MapView;
  clusterColor?: ColorModeEnum;
}
